export default __webpack_public_path__ + "542f14e8e5d4cd1f1ffa3d40a936c19c.svg";